import React, { useState } from 'react'
import introJs from 'intro.js';
import { config } from '../../../config'
import { ButtonsRight } from '../../../interfaces/UI'
import Tour from '../../utils/Tour'
import { TextHelp } from '../Help/HelpES'
import CardHelp from './CardHelp'
import { ReportErrorForm } from './ReportErrorForm'
import { useParams } from 'react-router-dom'
import { HelpBooksOptions } from './HelpBooksOptions'
import { HelpJournalsOptions } from './HelpJournalsOptions'
import { Portal } from './Portal';
import CalificaTuExperiencia from './ModalCalificacion';
import { useUser } from '../../../hooks';

interface HelpBookProps {
  viewButtons: ButtonsRight;
  openButtons: ButtonsRight;
  setOpenButtons: (buttons: ButtonsRight) => void
}

const HelpBook = ({ viewButtons, openButtons, setOpenButtons }: HelpBookProps) => {
  let { idRevista, idLibro } = useParams();
  const [showCalificacion, setShowCalificacion] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const typeLibro: string = idLibro ? "libro" : "revista";
  const [openReport, setOpenReport] = useState<boolean>(false)
  const [openTour, setOpenTour] = useState<boolean>(false)
  const { user } = useUser();

  const startTour = () => {
    setOpenTour(true);
  }

    const handleCloseCalificacion = () => {
    setShowCalificacion(false);
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  return (
    <>
      <div id="option-7" className={`aside__content ${openButtons.optHelp ? "active" : ""}`}>
        <div className="aside__content-header">
          <h3>Ayuda</h3>
          <button className="btn btn-rounded btn-rounded-transparent btn-close"
            onClick={() => {
              let tmpBtns: ButtonsRight = { ...openButtons }
              tmpBtns.optHelp = false
              setOpenButtons(tmpBtns)
            }}
          >
            <span className="btn__icon"
            ><i className="icon icon-vpro-close"></i
            ></span>
          </button>
        </div>

        <div className={`aside__content-data main-sb ${openReport ? "fadeon" : ""}`}>
          <div className="accordion-container">
            {typeLibro === 'libro' ? (<HelpBooksOptions/>) : (<HelpJournalsOptions/>)}
          </div>
        </div>
        <div className="aside__content-actions">
          <div className="sub-content">
            {/* aqui */}
            <ReportErrorForm idRecurso={idLibro || idRevista || ""} handleCloseReport={() => setOpenReport(false)} isOpen={openReport} />
            {/* <div id="subc-3" className={`sub-content__content ${openReport?"xpand":""}`}>
              
              <form action="https://www.google.com" target="_blank">

                <div className="sub-content__actions">
                  <button
                    type="button"
                    className="sub-button"
                    data-subc="subc-3"
                    aria-label="Cerrar ventana de reporte de errores"
                    onClick = { ()=> setOpenReport(false) }
                  >
                    <span className="sub-button__icon"
                      ><i className="icon icon-vpro-chevron-down"></i
                    ></span>
                  </button>
                </div>

                <div className="select-dd">
                  <select
                    name="capitulos"
                    id="report-select"
                    className="select-dd__select"
                  >
                    <option value="">Error de contenido</option>
                    <option value="">Error de interface</option>
                    <option value="">Sugerencia</option>
                  </select>
                  <span className="select-dd__arrow"></span>
                </div>

                <textarea
                  name=""
                  id="txtAreaReport"
                  className="txt-area"
                  cols={30}
                  rows={10}
                  placeholder="Por favor describa su caso"
                ></textarea>

                <button type="submit" className="btn btn-alt-secondary btn--fw">
                  <span className="btn__label">Reportar</span>
                </button>

              </form>

            </div> */}
          </div>



          {/* <button
            type="button"
            className="btn btn-alt-primary btn-alt-primary--red btn--fw sub-button"
            data-subc="subc-3"
            onClick={() => setOpenReport(!openReport)}
          >
            <span className="btn__label">Reportar</span>
          </button> */}

          {
            user && (
              <button
            type="button"
            className="btn btn-alt-primary btn-alt-primary--red btn--fw sub-button"
            data-subc="subc-3"
            onClick={() => setShowCalificacion(true)}
          >
            <span className="btn__label">Califica tu experiencia</span>
          </button>
            )
          }

          <button
            type="button"
            className="btn btn-alt-primary btn-alt-primary--red btn--fw sub-button"
            data-subc="subc-3"
            onClick={() => startTour()}
          >
            <span className="btn__label">Iniciar Tour</span>
          </button>

          <a type="button" className="btn btn-alt-secondary btn--fw btn--ayuda" href={config.urlSupport} target="_blank">
            <span className="btn__label">Ir al Centro de soporte</span>
            <i className="icon icon-vpro-new-win"></i>
          </a>
        </div>
        {/* <!-- content 3 end --> */}
      </div>
      <Tour
        open={openTour}
        setOpen={setOpenTour}
        viewButtons={viewButtons}
      ></Tour>
      {showCalificacion && (
        <Portal>
          <CalificaTuExperiencia
            onClose={handleCloseCalificacion}
            setShowNotification={setShowNotification}
          />
        </Portal>
      )}
    </>
  )
}

export default HelpBook
